<script>
    import {mapState, mapActions, mapGetters} from 'vuex'
    import comForm from './form.vue'
    import comTable from './table.vue'

    export default {
        props: {
            visible: {
                type: Boolean,
                default: false,
            },
            type: String,
        },
        data() {
            return {}
        },
        methods: {
            ...mapActions('subsidies/select', {
                search: 'search',
                back: 'back',
                clean: 'clean',
            }),
            close() {
                this.clean();
                this.$emit('close');
            },
            accept() {
                this.$emit('change', this.value);
                this.clean();
            },
        },
        computed: {
            ...mapState('subsidies/select', {
                loading: 'loading',
                tab: 'tab',
                value: 'value',
            }),
        },
        watch: {},
        components: {comForm, comTable},
        mounted() {

        },
        destroyed() {
            this.clean();
        },
    }
</script>
<template>
    <window title="Поиск сертификатов" :visible="visible" :close="close">
        <div class="select-subsidies-search" v-loading="loading">
            <div style="height: 350px;">
                <el-collapse-transition>
                    <div v-show="tab==='form'" @keyup.enter="search">
                        <el-form class="transition-box">
                            <com-form style="padding-top: 24px"></com-form>
                        </el-form>
                    </div>
                </el-collapse-transition>
                <el-collapse-transition>
                    <div v-show="tab==='list'">
                        <div class="transition-box">
                            <com-table></com-table>
                        </div>
                    </div>
                </el-collapse-transition>
            </div>
            <div style="text-align: right;">
                <el-button @click="close">Отмена</el-button>
                <el-button v-show="tab==='form'" @click="clean">Очистить</el-button>
                <el-button v-show="tab==='list'" @click="back">Назад</el-button>
                <el-button v-show="tab==='form'" type="primary" @click="search">Найти</el-button>
                <el-button v-show="tab==='list'" type="primary" :disabled="!value" @click="accept">Выбрать</el-button>
            </div>
        </div>
    </window>
</template>
<style lang="scss">
    .select-subsidies-search {

    }
</style>
